import React from 'react';
import { Box } from '@mui/material';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { statusTone } from '../../theme';

interface PriorityFlagProps {
  priority?: string | null;
}

const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
} as const;

/**
 * Priority is not a status, so it is not a chip: only High and Urgent show,
 * as text with an outlined flag. Low and Medium (the default) show nothing.
 */
const PriorityFlag: React.FC<PriorityFlagProps> = ({ priority }) => {
  const value = String(priority || '').trim().toUpperCase();
  if (value !== 'HIGH' && value !== 'URGENT') return null;
  const urgent = value === 'URGENT';
  return (
    <Box
      component="span"
      data-priority={value.toLowerCase()}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: '0.8125rem',
        fontWeight: 600,
        lineHeight: 1.4,
        whiteSpace: 'nowrap',
        color: urgent ? statusTone.problem.fg : 'text.secondary',
      }}
    >
      <FlagOutlinedIcon aria-hidden="true" sx={{ fontSize: 16 }} />
      {urgent ? 'Urgent' : 'High'}
      <Box component="span" sx={visuallyHidden}> priority</Box>
    </Box>
  );
};

export default PriorityFlag;
